import { Controller, UseFormReturn } from "react-hook-form";
import { InsuranceEntity } from "../entity";
import React, { memo, useCallback } from "react";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { ErrorField, WitLabel } from "../styles";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { Container } from "../../extras/EditExtra/styles";
import SmartSelector from "../../witadmin/CRUD/Common/SmartSelectorV2";
import { filterMessages } from "../../extras/messages";
import { ErrorMessage } from "@hookform/error-message";
import { useAllowedInventoryLines } from "../hooks/allowedInventoryLines.hook";

const messages = defineMessages({
  inventoryLines: { id: "insurance.form.inventoryLines", defaultMessage: "Inventory Lines" },
  required: {
    id: "insurance.form.inventoryLines.required",
    defaultMessage: "At least one inventory line must be selected",
  },
});

export const InventoryLinesComponent = memo((props: UseFormReturn<InsuranceEntity>) => {
  const intl = useIntl();
  const allowedInventoryLines = useAllowedInventoryLines();

  const handleOnChange = useCallback(
    (it: any) => {
      if (
        JSON.stringify(it) !== JSON.stringify(props.getValues("appliesToInventories.tickersList"))
      ) {
        props.setValue("appliesToInventories.tickersList", it);
        if (it.hasOwnProperty("value")) {
          props.setValue("appliesToInventories.tickersList", it.value);
        }
      }
    },
    [props]
  );

  return (
    <FormGroup as={Col}>
      <FormLabel column sm={12}>
        <WitLabel>
          <FormattedMessage {...messages.inventoryLines} />
        </WitLabel>
      </FormLabel>
      <Controller
        {...props.register("appliesToInventories.tickersList", {
          required: intl.formatMessage(messages.required),
        })}
        render={({ field: { ref, ...field } }) => (
          <Container className="witadmin-bs3 witadmin-bs3-parent">
            <SmartSelector
              initialValues={props.getValues("appliesToInventories.tickersList") || []}
              field={{
                fieldName: "inventoryLine",
                filterNames: [
                  intl.formatMessage(filterMessages.accommodation),
                  intl.formatMessage(filterMessages.conditions),
                  intl.formatMessage(filterMessages.ocupation),
                  intl.formatMessage(filterMessages.mealplan),
                ],
                defaultValue: [],
                options: allowedInventoryLines,
                staticFilters: {},
              }}
              {...field}
              onChange={handleOnChange}
            />
            <ErrorMessage
              errors={props.formState.errors}
              name="appliesToInventories.tickersList"
              render={({ message }) => <ErrorField>{message}</ErrorField>}
            />
          </Container>
        )}
      />
    </FormGroup>
  );
});
